import { useCallback } from "react";

import { useFetch } from "2g-hooks/fetch";
import { getFetcherForMethod } from "2g-utils-ajax";

import { UZIVATEL } from "b2b/api/paths";

export default function useUpdateUserLang() {
  const fetch = useFetch();
  return useCallback(
    jazyk => {
      fetch({
        url: UZIVATEL.userLang(),
        payload: {
          jazyk
        },
        fetcher: getFetcherForMethod("put")
      });
    },
    [fetch]
  );
}
